module.exports = __webpack_public_path__ + "static/media/ic_crop.496bdaa1.svg";